import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { videoList } from "@/mocks/videos";

export default function VideoSection() {
  const items = videoList.slice(0, 4);

  return (
    <section>
      <SectionHeading
        icon="ri-play-circle-line"
        title="推荐视频栏目"
        desc="影视MV、综艺片段、游戏视频，精彩内容随心看"
        actionTo="/video"
        actionLabel="更多视频"
      />

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {items.map((video) => (
          <Link
            key={video.id}
            to={`/detail/${video.id}`}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100"
          >
            <div className="relative h-40 w-full overflow-hidden">
              <img
                src={video.cover}
                alt={video.title}
                title={`${video.title} - 天天干天天干`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/10"></div>
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-background-50/90 text-primary-600 transition-transform duration-300 group-hover:scale-110">
                  <i className="ri-play-fill text-xl" aria-hidden="true"></i>
                </span>
              </span>
              <span className="absolute bottom-2 right-2 rounded bg-black/60 px-2 py-0.5 text-xs text-white">
                {video.duration}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-4">
              <h3 className="line-clamp-2 text-sm font-semibold leading-snug text-foreground-900 group-hover:text-primary-700">
                {video.title}
              </h3>
              <div className="mt-auto flex items-center justify-between pt-3 text-xs text-foreground-400">
                <span className="rounded bg-accent-100 px-2 py-0.5 text-accent-900">
                  {video.category}
                </span>
                <span>
                  <i className="ri-eye-line mr-1 align-middle" aria-hidden="true"></i>
                  {video.views}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}